import "../Assets/scss/base.scss";

interface PropTypes {
    children: any
}

const MainTemplate = (prop: PropTypes) => {

    const { children } = prop;

    return (
        <>
            <div className="page-main">
                {children}
            </div>
        </>
    )
}

export default MainTemplate;